import type { ListingStatus } from "../feed-state";

const STYLES: Record<ListingStatus, string> = {
  listed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  sold: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  cancelled: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  superseded: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
};

const LABELS: Record<ListingStatus, string> = {
  listed: "LISTED",
  sold: "SOLD",
  cancelled: "CANCELLED",
  superseded: "SUPERSEDED",
};

export function StatusBadge({ status }: { status: ListingStatus }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-bold tracking-wider rounded border ${STYLES[status]}`}
    >
      {LABELS[status]}
    </span>
  );
}
